import { groupBy } from "lodash";

import { basename, extname } from "fond/fileValidation";

import { FILE_BUNDLE_EXTENSIONS } from "./acceptedFiles";

/**
 * Groups files by their name without the extension.
 *
 * Multi-file formats share a basename, so each group holds one dataset: a
 * shapefile's .shp/.dbf/.prj/.shx, or a MapInfo set's .tab/.dat/.id/.map.
 */
export const groupFilesByBasename = (files: File[]): Record<string, File[]> => groupBy(files, (file) => basename(file.name));

/**
 * The extensions a bundle still needs before it can be read.
 *
 * Empty when the bundle is complete, and when it matches no known format.
 */
export const findMissingSidecarExtensions = (files: File[], extensionGroups: readonly (readonly string[])[] = FILE_BUNDLE_EXTENSIONS): string[] => {
  const extensions = files.map((file) => extname(file.name)?.toLowerCase()).filter((extension): extension is string => extension !== undefined);

  const group = extensionGroups.find((groupExtensions) => extensions.some((extension) => groupExtensions.includes(extension)));

  return group ? group.filter((extension) => !extensions.includes(extension)) : [];
};
